export default "__VITE_ASSET__B9C$qsc4__"